<template>
    <p>Dashboard</p>
</template>

<script>
  export default {
    components: {

    },
    beforeCreate:function(){
       

    }
  }

</script>
